import React from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import DeactivateUserTable from "../../../components/table/all-tables/usermanagementtable/DeactivateUserTable";
import LoginAsUser from "../../../components/loginasuser/LoginAsUser";
import { userManage } from "../../../locales/en";

const DeactivateUser = () => {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle
        mainTitle={userManage?.mainTitle}
        content={userManage?.content}
      />
      <AccessPageAction
        subheading={userManage?.deactiveUserBtn}
        alluser="/admin/access/user"
        allUserTitle={userManage?.activeUser}
        createuser="/admin/access/user/create"
        createUserTitle={userManage?.creteUser}
        deactivate="/admin/access/user/deactivated"
        deactivateTitle={userManage?.deactiveUserBtn}
        deleteuser="/admin/access/user/deleted"
        deleteUserTitle={userManage?.deleteUser}
      />
      <div className="row mb-3 mx-0">
        <div className="col-12">
          <DeactivateUserTable />
        </div>
      </div>
    </>
  );
};

export default DeactivateUser;
